import { TRANSACTION_ACTIONS } from '../../../constants/actions'
import { NUMBER_OF_RECORDS_PER_PAGE } from '../../../constants/app'
import { mergeToNewObject } from '../../../util/object.helpers'

export const transactionsProfile = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case TRANSACTION_ACTIONS.ON_GET_TRANSACTIONS:
      return mergeToNewObject(state, {
        pagination: {
          ...state.pagination,
          ...payload
        }
      })

    case TRANSACTION_ACTIONS.ON_GET_TRANSACTIONS_SUCCESS:
      const { totalTxCount, transactions } = payload
      return mergeToNewObject(state, {
        transactions,
        pagination: {
          ...state.pagination,
          totalTxCount
        }
      })

    case TRANSACTION_ACTIONS.ON_RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  transactions: [],
  pagination: {
    recordsPerPage: NUMBER_OF_RECORDS_PER_PAGE,
    pageNumber: 0,
    totalTxCount: 0
  }
}
